export default {
  'pages.404.subTitle': 'Desculpe, a página que você visitou não existe.',
  'pages.404.buttonText': 'Voltar ao Início',
};
